import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/assistant-api';

import {
    mutateAllCachedRequest,
    mutateDataAfterDeletingItem,
} from '../../../../helpers/swrMutateUtils';
import { useSwrRequestKeysToMutateFromContext } from '../../../../hooks/useSwrRequestKeysToMutateFromContext';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const DeletePromptModal = ({ id, name, setPrompts, onClose }) => {
    const [errorAlert, setErrorAlert] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const {
        requestKeysToMutate: {
            chatPrompts: chatPromptsKeys,
            promptsInPlaybooks: promptsInPlaybooksKeys,
        },
    } = useSwrRequestKeysToMutateFromContext();

    const handleDelete = async () => {
        try {
            setIsLoading(true);

            await client.delete(`${API.ROUTES.assistant.chatPrompt}${id}/`);

            setPrompts((prompts) => prompts.filter((prompt) => prompt.id !== id));

            mutateDataAfterDeletingItem({ requestKeysToMutate: chatPromptsKeys, id });
            mutateAllCachedRequest({ requestKeysToMutate: promptsInPlaybooksKeys });

            onClose();
        } catch (e) {
            setIsLoading(false);
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.status });
        }
    };

    return (
        <ConfirmDeletionModalPattern
            title="Delete Prompt?"
            handleDelete={handleDelete}
            onClose={onClose}
            isLoading={isLoading}
            confirmationTextStart="You are about to delete"
            confirmationTextEnd="are you sure you’d like to continue? This will remove the prompt from any playbook blocks."
            entityName={`${name},`}
            variant="secondary"
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            buttonsSize="md"
        />
    );
};

export default DeletePromptModal;
